"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _redux = require("redux");

var _createRootEpic = _interopRequireDefault(require("../epics/createRootEpic"));

var _reduxObservable = require("redux-observable");

var _createRootReducer = _interopRequireDefault(require("../createRootReducer"));

function configureStore(initialState, rootModule) {
  var middleware = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)((0, _createRootEpic.default)(rootModule));
  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
  return (0, _redux.createStore)((0, _createRootReducer.default)(rootModule), initialState, composeEnhancers(_redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2.default)(middleware).concat([epicMiddleware]))));
}

module.exports = exports.default;